var _defs, _polygon, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "35.2 2.54 14.52 40.9 9.44 40.9 30.13 2.54 35.2 2.54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.35,21.53c5.52-.45,9.19,3.05,9.53,8.48.4,6.28-2.64,11.36-9.48,10.88-10.13-.7-10.3-18.53-.05-19.37ZM34.98,25.59c-3.59.37-3.67,5.86-3.09,8.51.51,2.32,1.69,3.54,4.19,3.3,3.67-.36,3.64-6.72,2.77-9.28-.63-1.84-1.87-2.74-3.87-2.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24,19.66C-.42,16.15-.36,7.8,3.42,4.39c3.12-2.81,8.93-2.67,11.8.45,3.46,3.78,3.31,11.77-.67,15.16-3.03,2.58-8.44,2.4-11.31-.35ZM9.01,6.48c-2.08.1-3.01,1.58-3.4,3.46-.5,2.47-.46,7.75,2.76,8.33,4.76.85,5.11-4.97,4.48-8.26-.41-2.12-1.49-3.65-3.84-3.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.98,25.59c1.99-.2,3.23.69,3.87,2.53.88,2.56.9,8.92-2.77,9.28-2.49.24-3.68-.98-4.19-3.3-.58-2.64-.51-8.14,3.09-8.51Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.01,6.48c2.36-.12,3.44,1.42,3.84,3.53.63,3.28.28,9.11-4.48,8.26-3.23-.58-3.26-5.86-2.76-8.33.38-1.89,1.32-3.36,3.4-3.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlet);
export default __webpack_public_path__ + "static/media/outlet.ef4bbc7c.svg";
export { ForwardRef as ReactComponent };